<template>
  <div id="page-login">
    <div id="login-box">
      <div id="login-img">
        <img src="../assets/login-img.svg" alt="" />
      </div>
      <div id="login-form">
        <img src="../assets/logo-2.png" class="logo" />
        <p>Sisteme girebilmeniz için giriş yapmanız gerekmektedir</p>
        <form v-on:submit.prevent="login()">
          <div>
            <label for="p-user">Kullanıcı kodu</label>
            <input
              type="text"
              v-on:keydown.enter.prevent="atla()"
              v-model="user.code"
              id="p-user"
            />
          </div>
          <div>
            <label for="p-pwd">Şifre</label>
            <input type="password" v-model="user.pwd" id="p-pwd" ref="pwd" />
          </div>
          <button @click.prevent="login()" class="btn-blue" type="submit">
            <i class="fa fa fa-sign-in-alt"></i> Giriş Yap
          </button>
        </form>
      </div>
    </div>
    <div class="copyright">Osman Fırat Çalışkan - 2022</div>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "Login",
  data() {
    return {
      user: {
        code: "",
        pwd: "",
      },
      error: "",
    };
  },
  methods: {
    atla() {
      this.$nextTick(() => {
        this.$refs.pwd.focus();
      });
    },
    login() {
      this.$http({
        method: "post",
        url: "api/login.php",
        data: qs.stringify({
          code: this.user.code,
          pwd: this.user.pwd,
        }),
      })
        .then((request) => this.loginSuccessful(request))
        .catch(() => this.loginFailed());
    },
    loginSuccessful(req) {
      if (!req.data.login) {
        this.loginFailed();
        return;
      } else {
        this.$router.push("/");
        this.$snotify.success("Giriş başarılı", "pediatrim.net");
      }
    },

    loginFailed() {
      this.$snotify.error("Giriş başarısız oldu", "pediatrim.net");
    },
  },
};
</script>

<style lang="scss">
#page-login {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    padding-bottom: 5px;
  }

  hr {
    border-top: 1px solid $divider;
  }

  a {
    text-decoration: none;
  }

  .fr {
    float: right;
  }

  .cnt {
    text-align: center !important;
  }

  input[type="text"],
  input[type="password"],
  input[type="date"],
  input[type="datetime-local"],
  input[type="number"],
  select {
    border: 1px solid rgba(0, 0, 0, 0.1);
    outline: 0;
    padding: 0.3em;
    -webkit-transition: all 0.5s ease;
    background: white;
    font-family: Muli, Tahoma, Geneva, Verdana, sans-serif;
    min-height: 1.4em;
    transition: all 0.5s ease;
    -ms-box-sizing: content-box;
    -moz-box-sizing: content-box;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    &:focus,
    &:hover {
      border: 1px solid $accent;
    }
  }

  .radiobox {
    display: flex;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background-color: white;
    padding: 0.3em;
    flex-wrap: wrap;
  }

  [type="checkbox"]:checked,
  [type="checkbox"]:not(:checked),
  [type="radio"]:checked,
  [type="radio"]:not(:checked) {
    position: absolute;
    left: -9999px;
    width: 0;
    height: 0;
    visibility: hidden;
  }
  .checkbox + label {
    flex: 1 1 auto;
    padding: 2px;
    text-align: center;
    cursor: pointer;
    color: black;
  }
  .checkbox:checked + label {
    background-color: $accent;
    color: white;
  }
  .checkbox:not(:checked) + label {
    text-align: center;
    background-color: white;
    &:hover {
      background-color: transparentize($accent, 0.8);
    }
  }

  textarea {
    border: 1px solid rgba(0, 0, 0, 0.1);
    outline: 0;
    padding: 0.3em;
    font-size: 13px;
    resize: vertical;
    -webkit-transition: all 0.5s ease;
    font-family: Muli, Tahoma, Geneva, Verdana, sans-serif;
    min-height: 1.4em;
    transition: all 0.5s ease;
    background-color: white;
    &:focus,
    &:hover {
      border: 1px solid $accent;
    }
  }

  button {
    border: 0;
    outline: 0;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    color: #fff;
    padding: 8px !important;
  }

  .btn {
    padding: 5px;
    margin: 0 5px;
    font-weight: 700;
    transition: all 0.2s ease;
    display: inline-block;
  }

  a.btn {
    padding: 5px;
    margin: 0 5px;
    font-weight: 700;
    transition: all 0.5s ease;
    &:hover {
      color: $accent;
    }
    &:active {
      color: $primary;
    }
  }

  background-image: url("../assets/login-bg.jpg");
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
}

.copyright {
  text-shadow: 0 0 10px #ffffff;
  color: white;
  margin-top: 20px;
}

#login-box {
  display: flex;
  border-radius: 20px;
  flex-direction: row;
  width: 800px;
  box-shadow: 0 4px 25px 0 rgba(255, 255, 255, 0.5);
}

#login-img {
  flex: 1 1 400px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  background-color: $primary;
  img {
    margin: 50px;
  }
}

#login-form {
  flex: 1 1 400px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  background-color: $background;
  padding: 15px;
  img.logo {
    width: 100%;
    padding: 0 20px;
  }
  p {
    margin-top: 10px;
    margin-bottom: 30px;
  }
  label {
    font-size: 12px;
    display: block;
    width: 100%;
    margin: 5px 0;
  }
  input[type="text"],
  input[type="password"] {
    display: block;
    width: 100%;
    margin: 3px 0;
    padding: 8px;
    box-sizing: border-box;
  }
  button {
    margin-top: 20px;
  }
}

@media (max-width: 1280px) {
  #login-form {
    padding: 5px;
    .logo {
      width: 100% !important;
      max-width: 400px;
    }
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }
  #login-box {
    width: 95%;
    border: 2px solid $primary;
    background-image: none !important;
  }
  #login-img {
    display: none;
  }
}
</style>
